import React, { useEffect } from "react";
import { Formik, Form, Field } from "formik";
import isGHMC, { getCurrentDateTime, getStartOfCurrentDate } from "../../../Common/helper/helpar";
import { useFilterStore } from "../../AssetVehicle/store/useFilterStore";
import { useTripStore } from "../../Reports/SATReports/store/useTripStore";
import TippingFeeStore from "./store/TippingFeeStore";

export const TippingFeeFilterForm = () => {
    const { fetchZoneWiseTrips } = useTripStore();
    const { fetchFilterOwnerTypes, ownerTypes, fetchFilterCollectionTypes, collectionTypes } = useFilterStore();
    const { fetchTippingFee, tippingFeeData, addTippingFeeData, loading, fetchTippingFeeForMT, tippingFeeDataForMT } = TippingFeeStore();
    const isProd = isGHMC();
    const items = JSON.parse(localStorage.getItem("sat-trips-zone-filters")) || {};

    useEffect(() => {
        fetchFilterOwnerTypes();
        fetchFilterCollectionTypes();
    }, []);

    const initialTippingFeeFilterValues = {
        ownerTypeId: items?.ownerTypeId || "",
        collectionTypeId: items?.collectionTypeId || "",
        status: items?.status || "",
    };

    const handleSubmit = (values) => {
        // Pass the form values as query parameters to fetchTippingFee
        fetchTippingFee(values);
    };

    return (
        <div className="card bg-white mb-3 shadow" style={{ width: "99%" }}>
            <div className="card-body">
                <Formik
                    key={JSON.stringify(initialTippingFeeFilterValues)}
                    initialValues={initialTippingFeeFilterValues}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, resetForm }) => (
                        <Form>
                            <div className="row">
                                <div className="col-md-2 mb-3">
                                    <div className="form-group">
                                        <label className="form-label w-100 text-left">Collection Type</label>
                                        <Field
                                            as="select"
                                            name="collectionTypeId" // Corrected name
                                            className="form-select"
                                            value={values.collectionTypeId}
                                        >
                                            <option value="">Select</option>
                                            {collectionTypes?.map((type) => (
                                                <option key={type.collectionTypeId} value={type.collectionTypeId}>
                                                    {type.collectionTypeName}
                                                </option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <div className="form-group">
                                        <label className="form-label w-100 text-left">Owner Type</label>
                                        <Field
                                            as="select"
                                            name="ownerTypeId" // Corrected name
                                            className="form-select"
                                            value={values.ownerTypeId}
                                        >
                                            <option value="">Select</option>
                                            {ownerTypes.map((type) => (
                                                <option key={type.ownerTypeId} value={type.ownerTypeId}>
                                                    {type.ownerTypeName}
                                                </option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <div className="form-group">
                                        <label className="form-label w-100 text-left">Status</label>
                                        <Field
                                            as="select"
                                            name="status" // Corrected name
                                            className="form-select"
                                            value={values.status}
                                        >
                                            <option value="">Select</option>
                                            <option value="true">Active</option>
                                            <option value="false">InActive</option>
                                        </Field>
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex gap-2 align-items-end pb-3 mb-3">
                                    <button
                                        type="submit"
                                        className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};